module.exports = __webpack_public_path__ + "static/media/learner.0ae66df0.svg";